import React from 'react';
import Grid from '@mui/material/Grid2';
import { LocalFlorist, WaterDrop } from '@mui/icons-material'; // Icons for items like Wax, Shampoo
import DashboardButton from './DashboardButton';
import Typography from '@mui/material/Typography';

const items = [
  { name: "Wax", icon: <LocalFlorist fontSize="large" />, price: 6 },
  { name: "Haargel", icon: <LocalFlorist fontSize="large" />, price: 8 },
  { name: "Shampoo", icon: <WaterDrop fontSize="large" />, price: 20 },
  { name: "HairSpray", icon: <LocalFlorist fontSize="large" />, price: 10 },
  { name: "BartOil", icon: <LocalFlorist fontSize="large" />, price: 20 },
  { name: "Hairpuder", icon: <LocalFlorist fontSize="large" />, price: 10 },
  { name: "Cologne", icon: <LocalFlorist fontSize="large" />, price: 12 },
  { name: "Cologne Cream", icon: <LocalFlorist fontSize="large" />, price: 10 },
];

const ItemsSelection = ({ selectedItems, handleItemSelection }) => {
  return (
    <>
      <Typography component="h2" variant="h6" sx={{ mb: 3, fontWeight: 500 }}>
        Select Items
      </Typography>
      <Grid container spacing={3} sx={{ mb: 5 }}>
        {items.map((item) => (
         <Grid
                size={{ xs: 6, sm: 12 }} // 2 per row on mobile, full width on sm+
                key={item.name}
                sx={{ 
                  display: { sm: 'inline-flex' }, // Remove Grid styling on larger screens
                  maxWidth: { sm: '200px' } // Match DashboardButton's sm width
                }}
              >
            <DashboardButton
              text={`${item.name}`}
              secondaryText={`€${item.price}`}
              icon={item.icon}
              selected={selectedItems.some(selectedItem => selectedItem.name === item.name)}  // Check if item is in selectedItems array
              onClick={() => handleItemSelection(item)}  // Pass the entire item object
              size="small"
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ItemsSelection;
